import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ProductCategory, ProductCategoryService } from 'src/app/core/product-category.service';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';

@Component({
  selector: 'app-product-category-delete-dialog',
  templateUrl: './product-category-delete-dialog.component.html',
  styleUrls: ['./product-category-delete-dialog.component.scss'],
})
export class ProductCategoryDeleteDialogComponent {
  category?: ProductCategory;
  is_delete_running: boolean = false;

  constructor(
    private dialog_ref: MatDialogRef<ProductCategoryDeleteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: any,
    private product_category_service: ProductCategoryService,
    private error_service: ErrorService,
  ) {
    this.category = data.category;
  }

  onCloseClick(): void {
    this.dialog_ref.close();
  }

  onDeleteClick(): void {
    if (this.category?.product_category_id) {
      this.deleteCategory(this.category.product_category_id);
    }
  }

  deleteCategory(product_category_id: string): void {
    this.is_delete_running = true;
    this.product_category_service.deleteProductCategory(product_category_id).subscribe({
      next: () => {
        this.dialog_ref.close({ success: true });
        this.is_delete_running = false;
      },
      error: error => {
        const processed_error: SplittypayError = this.error_service.preProcessApiError(error);
        this.dialog_ref.close({ error: processed_error });
        this.is_delete_running = false;
      },
    });
  }
}
